module.exports = {"systemVersion":"1.0.48.2026113"}


//////////////////
// WEBPACK FOOTER
// ./static/js/version.json
// module id = taDY
// module chunks = 88